import React, { HTMLAttributes, ReactNode } from 'react'
import { card, CardVariants } from './Card.css'
import { AppTitle } from '../AppTitle'
import clsx from 'clsx'
import { AppText } from '../AppText'
import { Button } from '../Button'
import { PortableText, PortableTextComponents } from "next-sanity"
import { PortableTextObject } from "sanity"

interface CardProps extends HTMLAttributes<Element>, CardVariants {
	title?: string
	body?: PortableTextObject | string
	date?: string
	link?: string
}

export const Card: React.FC<CardProps> = ({
	title,
	body,
	theme = "primary",
	className,
	date,
	link
}) => {
	if (!title || !body) return null

	const { base, titleText, bodyText, button } = card({ theme })
	const components = {
		block: {
			normal: ({ children }: { children: ReactNode }) => (
				<AppText as="p" size="small" className={bodyText()}>
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: { children: ReactNode }) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	return (
		<div className={clsx(base(), className)}>
			{date && <AppText className={titleText()} size='h3' family='condensed' color='mainPink'>{date}</AppText>}
			<AppTitle as="h3" className={titleText()} variant={theme === "ternary" ? "h2" : "h3"}>{title}</AppTitle>
			{typeof body === "object" ? (
				<PortableText value={body} components={components} />
			) : (
				<AppText as="p" size="small" className={bodyText()}>{body}</AppText>
			)}
			{link && theme === "ternary" && <Button as="nextLink" href="/coming-soon" className={button()}>Discover our market</Button>}
		</div>
	)
}
